import type { CSSProperties, HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  flat?: boolean;
  lift?: boolean;
  children?: ReactNode;
}

export function Card({ flat, lift, className, children, ...rest }: CardProps) {
  return (
    <div className={cn(flat ? 'card-flat' : 'card', lift && 'lift', className)} {...rest}>
      {children}
    </div>
  );
}

/** Card with internal padding control and an optional hairline header. */
export function Panel({
  pad = true,
  title,
  action,
  children,
  style,
}: {
  pad?: boolean;
  title?: ReactNode;
  action?: ReactNode;
  children: ReactNode;
  style?: CSSProperties;
}) {
  return (
    <Card style={style}>
      {title && (
        <div className="row between hairline" style={{ padding: '15px 18px' }}>
          <div style={{ fontSize: 15, fontWeight: 600 }}>{title}</div>
          {action}
        </div>
      )}
      <div style={{ padding: pad ? 18 : 0 }}>{children}</div>
    </Card>
  );
}
